import { queryOptions } from '@tanstack/react-query'
import { nanoid } from 'nanoid'
import { getMapDeployments } from '@/features/filteredMap/mapDeployments/getMapDeployments'
import type {
	FilterGroup,
	MapFilter,
} from '../filteredMap/filters/models/models'
import {
	normaliseCountryCode,
	normaliseMarketName,
} from '../filteredMap/mapDeployments/utils'
// import initialSampleData from './data/initialMapDeployments.json'
import {
	type EnablementMapDeployment,
	validateServerReceivedEnablementMapDeployment,
} from './models/enablementSchema'

export const enablementMapDeploymentsQueryOptions = queryOptions({
	queryKey: ['enablementMapDeployments'],
	queryFn: async () =>
		getMapDeployments<EnablementMapDeployment>({
			localStorageKey: 'ogw_marketview-enablement-deployments',
			remoteUrl:
				'https://d3bj8knxlstxyw.cloudfront.net/marketview-assets-map-deployments.json',
			publicFolderUrl: '/json/marketview-assets-enablement.json',
			validationFunction: validateServerReceivedEnablementMapDeployment,
		}),
	staleTime: 1000 * 60 * 60, // 1 hour
})

export function createInitialEnablementFilterGroups(
	data: EnablementMapDeployment[]
): {
	filterGroups: FilterGroup[]
	initialData: EnablementMapDeployment[]
} {
	const filterList = [
		{
			name: 'channelPartner',
			displayName: 'Channel Partners',
			dataType: 'string',
		},
		{ name: 'status', displayName: 'Readiness Status', dataType: 'string' },
		{
			name: 'accreditation',
			displayName: 'Accreditation',
			dataType: 'stringArray',
		},
		{ name: 'region', displayName: 'Regions', dataType: 'string' },
		{ name: 'market', displayName: 'Markets', dataType: 'string' },
		{ name: 'provider', displayName: 'Providers', dataType: 'string' },
	] as const

	const filterGroups: FilterGroup[] = filterList.map((filterName, index) => ({
		id: nanoid(),
		name: filterName.name,
		displayName: filterName.displayName,
		order: index,
		filters: [],
		dataType: filterName.dataType,
	}))
	const normalisedData = data.map((deployment) => ({
		...deployment,
		market: normaliseMarketName(deployment.market),
		countryCode: normaliseCountryCode(deployment.countryCode),
	}))

	normalisedData.forEach((deployment) => {
		filterGroups.forEach((group) => {
			const deploymentKey =
				deployment[group.name as keyof EnablementMapDeployment]
			// check if value already exists in filters, if not add it

			if (Array.isArray(deploymentKey)) {
				// check if the deploymentKey is an array (for example channelPartner can be multiple), if it is we need to loop through the values and add them separately to the filters

				deploymentKey.forEach((key) => {
					if (!group.filters.some((f) => f.name === key)) {
						group.filters.push({
							id: nanoid(),
							name: key,
							isSelected: false,
							isSelectable: true,
							type: 'checkbox',
						} as MapFilter)
					}
				})
			} else {
				// if (
				// 	group.name === 'status' &&
				// 	typeof deploymentKey === 'string'
				// ) {
				// 	// for status filter we want to have only 3 options: live, upcoming, past
				// 	// const status = deploymentKey.toLocaleLowerCase()

				// } else
				if (!group.filters.some((f) => f.name === deploymentKey)) {
					group.filters.push({
						id: nanoid(),
						name: deploymentKey,
						isSelected: false,
						isSelectable: true,
						type: 'checkbox',
					} as MapFilter)
				}
			}

			// sort filters alphabetically
			group.filters = group.filters.toSorted((a, b) =>
				a.name.localeCompare(b.name)
			)
		})
	})

	return { filterGroups, initialData: normalisedData }
}

// function main() {
// 	const { filterGroups, initialData } = createInitialEnablementFilterGroups(
// 		initalSampleData.deployments as EnablementMapDeployment[]
// 	)

// 	const d = filterGroups.filter((f) => f.name === 'status')
// 	console.log(JSON.stringify(d, null, 2))
// }

// main()
